// filters-active-bar.js
// Buduje pasek aktywnych filtrów (chipy z ✕) nad siatką produktów.
// Czyta zaznaczone opcje z natywnego filtra Glozin i pozwala je usuwać.
// (działa w układzie pionowym, poziomym i w szufladzie — selektor .collection-sidebar)

(function () {
  'use strict';

  var BAR_ID = 'active-filters-bar';

  function cleanLabel(text) {
    if (!text) return '';
    return text
      .replace(/\s*\(\d+\)\s*$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getActiveFilters() {
    var root = document.querySelector('.collection-sidebar');
    if (!root) return [];
    var seen = {};
    var out = [];
    var links = root.querySelectorAll('.link-filter, a.link-filter, .filter-content a');
    links.forEach(function (link) {
      var checkedBox = link.querySelector('.checkbox.checked, .checkbox.checked-color');
      var colorDot = link.querySelector('[data-filter-color-dot].checked-color');
      var selfChecked = link.classList.contains('checked') ||
        link.classList.contains('active') ||
        link.getAttribute('aria-pressed') === 'true';
      if (!checkedBox && !colorDot && !selfChecked) return;

      var label = cleanLabel(link.getAttribute('data-label') || link.textContent);
      if (!label) return;
      var key = label.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      out.push({ label: label, link: link });
    });
    return out;
  }

  function findClearAll() {
    var root = document.querySelector('.collection-sidebar') || document;
    var candidates = root.querySelectorAll('a, button');
    for (var i = 0; i < candidates.length; i++) {
      var t = (candidates[i].textContent || '').toLowerCase();
      if (t.indexOf('wyczyść') !== -1 || t.indexOf('wyczysc') !== -1 ||
          t.indexOf('clear all') !== -1 || t.indexOf('usuń wszystk') !== -1) {
        return candidates[i];
      }
    }
    return null;
  }

  function removeFilter(item) {
    try {
      item.link.click();
    } catch (e) {
      if (item.link.href) window.location.href = item.link.href;
    }
  }

  function clearAll() {
    var clearBtn = findClearAll();
    if (clearBtn) {
      clearBtn.click();
    } else {
      window.location.href = window.location.pathname;
    }
  }

  function buildBar(filters) {
    var bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'active-filters-bar';

    var label = document.createElement('span');
    label.className = 'active-filters-bar__label';
    label.textContent = 'Aktywne filtry:';
    bar.appendChild(label);

    filters.forEach(function (item) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'active-filter-chip';
      chip.innerHTML = '<span class="active-filter-chip__text"></span><span class="active-filter-chip__x" aria-hidden="true">\u2715</span>';
      chip.querySelector('.active-filter-chip__text').textContent = item.label;
      chip.setAttribute('aria-label', 'Usuń filtr ' + item.label);
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        removeFilter(item);
      });
      bar.appendChild(chip);
    });

    if (filters.length > 1) {
      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'active-filters-clear';
      clear.textContent = 'Wyczyść wszystko';
      clear.addEventListener('click', function (e) {
        e.preventDefault();
        clearAll();
      });
      bar.appendChild(clear);
    }

    return bar;
  }

  function render() {
    var existing = document.getElementById(BAR_ID);
    if (existing) existing.remove();

    var filters = getActiveFilters();
    if (!filters.length) return;

    var anchor = document.querySelector('#product-grid') ||
      document.querySelector('#productgridcontainer');
    if (!anchor) return;

    var bar = buildBar(filters);
    anchor.parentNode.insertBefore(bar, anchor);
  }

  var scheduled = false;
  function scheduleRender() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      render();
    }, 120);
  }

  function init() {
    render();
    var target = document.querySelector('#CollectionSidebar') ||
      document.querySelector('.collection-sidebar') ||
      document.body;
    var observer = new MutationObserver(scheduleRender);
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
